<template>
  <BModal
    :model-value="modal"
    scrollable
    centered
    @update:modelValue="updateModal"
  >
    <template #header>
      <div
        class="d-flex align-items-center justify-content-between modal-title w-100"
      >
        <h5 class="">Staff</h5>
      </div>
      <BButton variant="link" class="close" @click="closeModal">
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>

    <div>
      <BContainer>
        <BRow>
          <BCol cols="3">
            <BFormSelect
              id="prefix"
              v-model="staffForm.alias"
              :options="prefixOptionsField"
              class="form-control"
            >
              <template #first>
                <BFormSelectOption :value="null" disabled>
                  Select Alias
                </BFormSelectOption>
              </template>
            </BFormSelect>
          </BCol>
          <BCol cols="9">
            <BFormInput
              id="fullname"
              v-model="staffForm.fullname"
              placeholder="Name"
              class="form-group"
            />
          </BCol>
        </BRow>
        <BRow>
          <BCol>
            <BFormInput
              id="email"
              v-model="staffForm.email"
              placeholder="Email"
              class="form-group"
              :disabled="staffData.uuid"
            />
          </BCol>
        </BRow>
        <BRow>
          <BCol>
            <BFormInput
              id="phone"
              v-model="staffForm.phone"
              placeholder="Phone"
              class="form-group"
            />
          </BCol>
        </BRow>
        <BRow>
          <BCol>
            <BFormInput
              id="address"
              v-model="staffForm.address"
              placeholder="Address"
              class="form-group"
            />
          </BCol>
        </BRow>
        <BRow>
          <BCol>
            <BFormSelect
              id="position"
              v-model="selectedPosition"
              :options="positionOption"
              class="form-control"
              :disabled="isPositionLocked"
            >
              <template #first>
                <BFormSelectOption value="" disabled
                  >Select Position</BFormSelectOption
                >
              </template>
            </BFormSelect>
          </BCol>
        </BRow>
        <BRow v-if="staffData.uuid" class="mt-3">
          <BCol>
            <BFormSelect
              id="status"
              v-model="staffForm.status"
              :options="statusOptionsField"
              class="form-control"
            />
          </BCol>
        </BRow>
      </BContainer>
    </div>
    <template #footer>
      <BButton variant="primary" @click="handleAction">{{
        staffData && staffData.uuid ? "Update" : "Save"
      }}</BButton>
      <BButton variant="secondary" @click="closeModal">Cancel</BButton>
    </template>
  </BModal>

  <ToastResponse
    v-model="modalResponse.toast"
    :text="modalResponse.text"
    :success="modalResponse.success"
  />
</template>

<script>
import {
  BModal,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BFormSelect,
  BContainer,
} from "bootstrap-vue-next";
import { ref, inject, watch, computed } from "vue";
// import axios from "axios";
import ToastResponse from "@/components/ToastResponse.vue";

export default {
  components: {
    BModal,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BFormSelect,
    BContainer,
    ToastResponse,
  },

  props: {
    modal: Boolean,
    staffData: Object,
  },
  emits: ["update:modal", "addOrUpdate"],

  setup(props, { emit }) {
    const repositories = inject("repositories");
    const staffRepository = repositories ? repositories.employee : null;
    const positionRepository = repositories ? repositories.staffPosition : null;
    // const positionRepository = repositories ? repositories.staffPosition : null;

    const positionOption = ref([]);
    const selectedPosition = ref(null);

    const staffForm = ref({
      alias: null,
      fullname: "",
      phone: "",
      email: "",
      address: "",
      status: "active",
    });

    const resetForm = () => {
      staffForm.value = {
        alias: null,
        fullname: "",
        phone: "",
        email: "",
        address: "",
        status: "active",
      };
    };

    const prefixOptionsField = ref([
      { value: null, text: "Alias", disabled: true },
      { value: "Mr.", text: "Mr." },
      { value: "Ms.", text: "Ms." },
      { value: "Mrs.", text: "Mrs." },
    ]);

    const statusOptionsField = [
      { value: "active", text: "Active" },
      { value: "non-active", text: "Inactive" },
    ];

    const modalResponse = ref({
      toast: false,
      text: "",
      success: false,
    });

    const updateModal = (value) => {
      emit("update:modal", value); // Sync modal state with parent
    };

    const closeModal = () => {
      updateModal(false); // Sync modal state with parent
      resetForm();
      selectedPosition.value = null;
    };

    const handleAction = () => {
      props.staffData?.uuid ? update() : create();
    };

    const isPositionLocked = computed(() => {
      return props.staffData.uuid && props.staffData.user !== null;
    });

    const create = async () => {
      // Masukkan position_uuid yang dipilih ke staffForm
      staffForm.value.position_uuid = selectedPosition.value;

      await staffRepository
        .create(staffForm.value)
        .then(() => {
          updateModal(false);
          staffForm.value = { status: "active" };
          selectedPosition.value = null;

          modalResponse.value = {
            toast: true,
            text: "Staff created successfully",
            success: true,
          };
          emit("addOrUpdate");
          resetForm();
        })
        .catch((err) => {
          console.error(err);
          Object.assign(modalResponse.value, {
            success: false,
            text: err.response.data.error,
            toast: true,
          });
        });
    };

    const update = async () => {
      staffForm.value.position_uuid = selectedPosition.value;
      await staffRepository
        .update(staffForm.value, props.staffData.uuid)
        .then(() => {
          updateModal(false);
          // staffForm.value = {};
          selectedPosition.value = null;
          modalResponse.value = {
            toast: true,
            text: "Staff updated successfully",
            success: true,
          };
          emit("addOrUpdate");
          resetForm();
        })
        .catch((err) => {
          console.log(err);
          Object.assign(modalResponse.value, {
            success: false,
            text: err.response.data.error,
            toast: true,
          });
        });
    };

    watch(
      () => props.staffData,
      (newData) => {
        if (newData) {
          staffForm.value = { ...staffForm.value, ...newData };
          selectedPosition.value = newData.position_uuid || null;

          if (
            newData.position_uuid &&
            !positionOption.value.find(
              (pos) => pos.value === newData.position_uuid
            )
          ) {
            positionOption.value.push({
              value: newData.position_uuid,
              text: newData.position_name || "Unknown Position",
            });
          }
        }
      },
      { immediate: true }
    );
    watch(
      () => props.modal,
      async (newVal) => {
        if (newVal) {
          console.log("selectedPosition awal:", selectedPosition.value);
          console.log("staffForm awal:", staffForm.value.alias);

          try {
            const res = await positionRepository.getAll();
            positionOption.value = [
              { value: null, text: "Select Position", disabled: true },
              ...res.data.data.map((item) => ({
                value: item.uuid,
                text: item.name,
              })),
            ];
          } catch (err) {
            console.error("Failed to fetch positions", err);
          }
        } else {
          resetForm();
          selectedPosition.value = null;
        }
      }
    );

    return {
      staffForm,
      selectedPosition,
      positionOption,
      prefixOptionsField,
      statusOptionsField,
      handleAction,
      updateModal,
      closeModal,
      modalResponse,
      create,
      update,
      isPositionLocked,
    };
  },
};
</script>
